import React, { useEffect, useState } from 'react';
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBInput, MDBBtn, MDBIcon } from 'mdb-react-ui-kit';
import { useLocation, useNavigate } from 'react-router-dom';
import gymLogo from '../../components/images/Easy-MembrLogo.png';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { getBussinessInfobyUrl, memberByNumber, verifyNumber } from '../../services/memberApiServices';
import { useAnalytics } from '../../hooks/useAnalytics';

const MemberLogin = () => {
    const { trackButtonClick } = useAnalytics();
    const { state } = useLocation();
    const [step, setStep] = useState(1);
    const [mobile, setMobile] = useState('');
    const [otp, setOtp] = useState('');
    const [countdown, setCountdown] = useState(60);
    const [error, setError] = useState('');
    const [notp, setNotp] = useState("");
    const [verify, setVerify] = useState(false)
    const [userExists, setUserExists] = useState(false);
    const navigate = useNavigate();

    console.log(error, 'error');




    const [bussinessinfo, setbusinessinfo] = useState(null)
    const hostname = window.location.hostname;
    let subdomain = "";
    console.log(hostname, 'hostname');

    if (hostname.endsWith('easymembr.com') || hostname.endsWith('zencruz.com')) {
        const parts = hostname.split('.');
        if (parts.length === 3 && parts[0] !== 'www' && parts[0] !== "app" && parts[0] !== "beta") {
            subdomain = parts[0];
        }
    }


    console.log('Subdomain:', subdomain);

    useEffect(() => {
        if (localStorage.getItem("loggedMemberInfo") && localStorage.getItem("memberinfo")) {
            navigate('/memberdashboard')
        }
        const fetchBusiness = async () => {
            const identifier = subdomain;
            const type = subdomain ? 'subdomain' : 'prefix';

            const response = await getBussinessInfobyUrl(identifier, type);

            if (!response || response === "false") {
                return;
            }

            const businessInfo = await response.json();
            console.log(businessInfo);
            setbusinessinfo(businessInfo);
            if (localStorage.getItem("loggedMemberInfo") && localStorage.getItem("memberinfo")) {
                navigate('/memberdashboard')
                // return
            }
        };

        if (subdomain !== "") {
            fetchBusiness();
        }
    }, []);



    console.log(bussinessinfo, 'bussinessinfo');


    const handleMobileSubmit = async (e) => {

        e.preventDefault();
        if (!isValidPhoneNumber(mobile)) {
            setError("Please enter valid contact number!");
        }
        else {
            const response = await verifyNumber({ phone: mobile });
            let resData = await response.json();
            // console.log(resData);
            if (resData.status !== 200) {
                setError("Please try again.")
            }
            else {
                setError("OTP Sent Sucessfully");
                setUserExists(true);
                setNotp(resData.otp);

            }
        }
        setError('');
        setStep(2);
        startCountdown();
    };

    function updateLoginUser(value) {
        // e.preventDefault();
        setMobile(value);
        setOtp("");
        setUserExists(false);
        setError("");
    }

    const setMemberdata = (memberinfo) => {

        const update = {
            number: memberinfo?.number,
            username: memberinfo?.fname ? memberinfo.fname + " " + memberinfo.lname : null,
            fname: memberinfo?.fname ? memberinfo?.fname : null,
            lname: memberinfo?.lname ? memberinfo?.lname : null,
            imgurl: memberinfo?.imgurl ? memberinfo?.imgurl : null,
            gymid: memberinfo?.bId ? memberinfo?.bId : -1,
            id: memberinfo?._id ? memberinfo?._id : -1,

        }

        localStorage.setItem("memberinfo", JSON.stringify(update))

    }

    const fetchMembers = async (gymid, number) => {

        const membersinfo = await memberByNumber(gymid, { number: number }, "user");
        const contentType = membersinfo.headers.get("content-type");

        if (!contentType || !contentType.includes("application/json")) {
            const text = await membersinfo.text();
            console.error("Expected JSON but got:", text);
            return;
        }

        if (!membersinfo || membersinfo === "false") {
            return;
        }

        const members = await membersinfo.json();
        console.log(members, 'members')


        if (members.length > 0) {

            setMemberdata(members[0]);
            trackButtonClick("MemberLogin", "Member_Login", "member", {});
            navigate(state?.path ? state?.path : '/memberdashboard');
        } else {
            const redirectPath = state?.path ? state?.path : '/memberdashboard';

            const waiverstatus = state?.waiverstatus ? state?.waiverstatus : false;
            localStorage.setItem("redirectPath", JSON.stringify(redirectPath));
            navigate("/membersignup", { state: { path: redirectPath, waiverstatus: waiverstatus } });
            // navigate("/membersignup", { state: { path: state?.path ? state?.path : "/memberdashboard" } });
        }

    };
    console.log(state?.path);

    const handleOtpSubmit = async (e) => {
        e.preventDefault();

        if (otp !== notp) {
            setError("Invalid OTP.Please try again.");
        }
        else {
            setError("");
            setVerify(true)
            console.log("inside otpsubmit");

            const update = {
                gymid: bussinessinfo?._id,
                number: mobile,
                gymname: bussinessinfo?.businessName,
                // gymid: "675bdd8de17f8e061cf052c5",
                // gymname: "Demo"

            }
            localStorage.setItem("loggedMemberInfo", JSON.stringify(update))
            await fetchMembers(update.gymid, update.number)

        }

    };

    const startCountdown = () => {
        setCountdown(60);
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const resendOtp = (e) => {
        startCountdown();
        setOtp('')
        handleMobileSubmit(e)

    };

    return (
        <div className="member-loginpage">
            <MDBCard className="shadow-5">
                <MDBCardBody className="p-5 text-center">
                    <div className='memberloginheader mb-4 '>
                        <img
                            src={bussinessinfo?.logourl ? bussinessinfo?.logourl : gymLogo}
                            className='membergym-logo'
                            alt="Gym Logo" />
                        <div className='position-relative'>
                            <div className='log-content'>
                                <h5 className="mb-0">Member </h5>
                                <h4>Login</h4>
                            </div>
                            <span className='login-line'></span>
                        </div>
                    </div>
                    {step === 1 ? (
                        <form onSubmit={handleMobileSubmit}>
                            <div className="text-start mb-2">
                                <label className="form-label text-dark fw-bold mb-1"> Mobile number</label>
                                <PhoneInput
                                    className="form-control input-mobile"
                                    defaultCountry="IN"
                                    placeholder="10-digit mobile number"
                                    value={mobile}
                                    // disabled={userExists}
                                    onInput={(e) => e.target.value = e.target.value.slice(0, 15)}
                                    onChange={(value) => updateLoginUser(value)}
                                />

                                {error != "" && <div className="text-danger">{error}</div>}

                                <label className="form-label pt-1 text-secondary">Enter your registered mobile number</label>
                            </div>
                            <MDBBtn
                                type="submit"
                                className="nav-btn logbtn"
                                color="primary"
                                block
                                disabled={!mobile || !isValidPhoneNumber(mobile)}
                            >
                                <span> Send OTP</span>
                            </MDBBtn>
                            <p className="text-muted pt-1">
                                <MDBIcon fas icon="info-circle me-1" /> We'll send a one-time password to your mobile
                            </p>
                        </form>
                    ) : (
                        <form onSubmit={handleOtpSubmit}>
                            <div className="text-start mb-3">
                                {error != "" && <div className="text-danger">{error}</div>}
                                <label className="form-label text-dark fw-bold mb-1"> OTP</label>
                                <MDBInput
                                    type="tel"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    placeholder="6-Digit OTP"
                                    maxLength="6"
                                    className=" text-center letter-spacing input-mobile"
                                    style={{ letterSpacing: '1px', fontSize: '1.2rem' }}
                                />
                                <label className="form-label pt-1 mb-0 text-secondary">Enter the 6-Digit OTP sent to ******{mobile.slice(-4)}</label>


                            </div>
                            <MDBBtn
                                type="submit"
                                color="primary"
                                className="nav-btn logbtn"
                                block
                                disabled={otp.length !== 6}
                            >
                                <span> Verify & Login</span>
                            </MDBBtn>

                            <div className="d-flex justify-content-between py-2 virify-btn">
                                <button
                                    type="button"
                                    className="btn btn-link p-0"
                                    onClick={() => setStep(1)}
                                >
                                    Change Number
                                </button>

                                {countdown > 0 ? (
                                    <span className=" text-muted">
                                        Resend OTP in <span className='text-danger'> {countdown} s</span>
                                    </span>
                                ) : (
                                    <button
                                        type="button"
                                        className="btn btn-link p-0"
                                        onClick={(e) => resendOtp(e)}
                                    >
                                        <u> Resend OTP</u>
                                    </button>
                                )}

                            </div>
                        </form>
                    )}
                    <p className="text-muted">
                        New to our gym? <a href="/membersignup">Register here</a>
                    </p>
                    <div className="mt-4">
                        <p className="text-muted supp-footer">
                            <span>  Having trouble? </span> <a href="/contactus"> <u>  <MDBIcon fas icon="headset" className='me-1' /> Contact support</u></a>
                        </p>
                    </div>
                </MDBCardBody>
            </MDBCard>
        </div >
    );
};

export default MemberLogin;